import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { MeUser } from "#permissions/types";

/** `/users/me` plus the Intercom hash. `memberships` and `staff` ride along from the server (ENG-11160). */
export type UserState = (MeUser & { intercomHash?: string }) | null;

const userInitialState = null as UserState;

export const userSlice = createSlice({
    name: "user",
    initialState: userInitialState,
    reducers: {
        setUser: (_, action: PayloadAction<UserState>) => action.payload,
        clearUser: () => null,
    },
});

export const { setUser, clearUser } = userSlice.actions;
